import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'app-card-layout-content-description',
  template: `
    <div class="card-layout-content-description p-text-center">
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./card-layout-content-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardLayoutContentDescriptionComponent {
  constructor() {}
}
